import { STORAGE_KEYS } from '../../config/storageKeys';

const TERMINAL_CONTINUATION_TYPES = new Set([
  'handoff_claimed',
  'handoff_expired_or_invalid',
  'handoff_already_claimed',
]);

/**
 * Shared handling for the landing-chat-handoff continuation info an auth
 * call may return (continuation_type, claimed_chat_session_id,
 * handoff_retry_token). Never changes navigation — only clears or retains
 * the cached sessionStorage handoff state, per the terminal/retryable rule:
 * clear on any of the three terminal outcomes, retain on
 * handoff_claim_failed_retryable so the opportunistic retry hook can try
 * again later.
 */
export function applyHandoffContinuation(authResult) {
  if (!authResult || typeof authResult !== 'object') return;
  const continuationType = authResult.continuation_type;
  if (!continuationType) return; // no handoff was in play at all

  if (TERMINAL_CONTINUATION_TYPES.has(continuationType)) {
    sessionStorage.removeItem(STORAGE_KEYS.PENDING_HANDOFF_TOKEN);
    sessionStorage.removeItem(STORAGE_KEYS.PENDING_HANDOFF_PROMPT_ID);
    sessionStorage.removeItem(STORAGE_KEYS.PENDING_HANDOFF_RETRY_TOKEN);
    return;
  }

  if (continuationType === 'handoff_claim_failed_retryable') {
    // Retain PENDING_HANDOFF_TOKEN/PROMPT_ID as-is. If this outcome came
    // from a magic-link flow, the backend additionally hands back a
    // short-lived retry credential this device can use even though it may
    // never have had the raw token in sessionStorage — cache it too.
    if (authResult.handoff_retry_token) {
      sessionStorage.setItem(STORAGE_KEYS.PENDING_HANDOFF_RETRY_TOKEN, authResult.handoff_retry_token);
    }
  }
}

export function clearAllPendingHandoffState() {
  sessionStorage.removeItem(STORAGE_KEYS.PENDING_HANDOFF_TOKEN);
  sessionStorage.removeItem(STORAGE_KEYS.PENDING_HANDOFF_PROMPT_ID);
  sessionStorage.removeItem(STORAGE_KEYS.PENDING_HANDOFF_RETRY_TOKEN);
}

export function getPendingHandoffToken() {
  return sessionStorage.getItem(STORAGE_KEYS.PENDING_HANDOFF_TOKEN);
}

export function getPendingHandoffRetryToken() {
  return sessionStorage.getItem(STORAGE_KEYS.PENDING_HANDOFF_RETRY_TOKEN);
}
